"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const Typography_1 = require("../Typography/Typography");
function Badge({ children, size = 'medium', variant, showBackgroundColor = false, className = '' }) {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, classnames_1.default)('rounded-full', 'border', 'inline-flex', 'justify-center', 'items-center', 'max-w-full', {
            'bg-white': !showBackgroundColor,
            'h-[26px]': size === 'medium',
            'h-9': size === 'large',
            'border-blue-80 text-blue-90': variant === 'primary',
            'border-yellow-70 text-yellow-95': variant === 'warning',
            'border-green-50 text-green-80': variant === 'positive',
            'border-red-50 text-red-90': variant === 'negative',
            // Adding a background color to badge can be as needed bases so controlling that via a prop
            'bg-blue-0': variant === 'primary' && showBackgroundColor,
            'bg-yellow-10': variant === 'warning' && showBackgroundColor,
            'bg-green-5': variant === 'positive' && showBackgroundColor,
            'bg-red-5': variant === 'negative' && showBackgroundColor
        }, className) }, { children: (0, jsx_runtime_1.jsx)(Typography_1.Typography, Object.assign({ variant: size === 'large' ? 'h200' : 'h100', className: (0, classnames_1.default)('flex', 'items-center', {
                'px-4': size === 'large',
                'px-3': size === 'medium'
            }) }, { children: children })) })));
}
exports.Badge = Badge;
//# sourceMappingURL=Badge.js.map